<template>
  <div class="p-5 bg-white shadow overflow-hidden sm:rounded-lg w-full sm:mt-6">
    <div class="space-y-8 divide-y divide-gray-200">
      <div class="space-y-8 divide-y divide-gray-200">
        <div>
          <div>
            <h3 v-if="update" class="text-lg leading-6 font-medium text-gray-900">
              Update Job
            </h3>
            <h3 v-if="!update" class="text-lg leading-6 font-medium text-gray-900">
              Create Job
            </h3>
            <p class="mt-1 text-sm text-gray-500">
              Jobs are tasks generated for the cleaners of your studio. Please specify a date, time and description of the job.
            </p>
          </div>

          <div class="mt-6 grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-6">
            <div class="sm:col-span-3">
              <label
                for="country"
                class="block text-sm font-medium text-gray-700"
              >
                Date of job
              </label>
              <div class="mt-1">
                <date-picker v-model="job.dateOfJob" valueType="timestamp" type="date" :placeholder='job.dateOfJob | moment("timezone", "Europe/Brussels","dddd, MMMM Do YYYY")'></date-picker>
              </div>
            </div>
            <div class="sm:col-span-3" v-if="!update">
              <label
                for="country"
                class="block text-sm font-medium text-gray-700"
              >
                Studio
              </label>
              {{job.studio}}
              <div class="mt-1">
                <select
                  id="country"
                  name="country"
                  autocomplete="country"
                  class="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                  v-model='selectedStudio'
                >
                  <option v-for="studio in studios" :value="studio" :key="studio._id">
                    {{ studio.description }}
                  </option>
                </select>
              </div>
            </div>

            <div class="sm:col-span-6">
              <label
                for="about"
                class="block text-sm font-medium text-gray-700"
              >
                Description
              </label>
              <div class="mt-1">
                <textarea
                  id="about"
                  name="about"
                  rows="3"
                  class="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                  v-model="job.description"
                  placeholder="Write a few sentences about the job."
                ></textarea>
              </div>
            </div>

            <div class="sm:col-span-3" v-if="!update">
              <label for="myCleaners" class="block text-sm font-medium text-gray-700">
                Choose posting option:
              </label>
              <div class="flex space-x-4 mt-2">
                <button 
                  :class="{'bg-indigo-300 text-white': postScope === 'myCleaners', 'bg-white text-gray-700': postScope !== 'myCleaners'}"
                  class="py-2 px-4 border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                  @click="postScope = 'myCleaners'"
                >
                  Post to My Cleaners
                </button>
                <button 
                  :class="{'bg-indigo-300 text-white': postScope === 'allCleaners', 'bg-white text-gray-700': postScope !== 'allCleaners'}"
                  class="py-2 px-4 border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                  @click="postScope = 'allCleaners'"
                >
                  Post to All Cleaners
                </button>
              </div>
              
              <!-- Display selected option -->
              <div v-if="postScope === 'myCleaners' && selectedStudio && selectedStudio.cleaner" class="p-4 bg-white rounded shadow-lg mt-6">
                <ul>
                    <li v-for="cleaner in selectedStudio.cleaner" :key="cleaner._id" class="p-2 border-b border-gray-200">
                        <input type="checkbox" :checked="!job.rejectedCleaners.includes(cleaner._id)"  @change="toggleRejection(cleaner._id, $event.target.checked)">
                        <label :for="cleaner._id">{{ cleaner.firstname }} {{ cleaner.lastname }}</label>
                    </li>
                </ul>
            </div>

              <div v-if="postScope === 'allCleaners'" class="p-4 bg-white rounded shadow-lg mt-6">
                <p>The job will be posted to all cleaners on the platform, and they are able to accept.</p>
              </div>
            </div>

          </div>
        </div>
      </div>

      <div class="pt-5">
        <div class="flex justify-end">
          <button
            @click="goto('/')"
            type="button"
            class="bg-white py-2 px-4 border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
          >
            Cancel
          </button>
                    <button
                    v-if="update"
            @click="editJob()"
            class="ml-3 inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
          >
            Update
          </button>
          <button
          v-if="!update"
            @click="createJob()"
            class="ml-3 inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
          >
            Post
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
// import inputWithLabel from "./../../auth/components/inputWithLabel";
// import actionButton from "../../auth/components/actionButton.vue";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import { mapGetters } from "vuex";
// import moment from 'moment'

export default {
  name: "createJob",
  data() {
    return {
      update: false,
      job: {
        postAll: false,
        rejectedCleaners: [],
      },
      selectedStudio: {},
      selectedCleaner: {},
      postScope: 'myCleaners',
    };
  },
  components: {
    // inputWithLabel,
    // actionButton,
    DatePicker,
  },
  computed: {
    ...mapGetters("job", {
      jobs: "jobList",
    }),
    ...mapGetters("studio", {
      studios: "studioList",
    }),
  },
  methods: {
    toggleRejection(cleanerId, isChecked) {
      const index = this.job.rejectedCleaners.indexOf(cleanerId);
      
      if (isChecked) {
        // If the checkbox is checked and the cleanerId is in rejectedCleaners, remove it
        if (index !== -1) {
          this.job.rejectedCleaners.splice(index, 1);
        }
      } else {
        // If the checkbox is not checked and the cleanerId is not in rejectedCleaners, add it
        if (index === -1) {
          this.job.rejectedCleaners.push(cleanerId);
        }
      }
    },
    createJob() {
    let date = new Date(this.job.dateOfJob)
    let userTimezoneOffset = date.getTimezoneOffset() * 60000;
    let test = new Date(date.getTime() - userTimezoneOffset - 3600000);

      this.job.dateOfJob = test.toISOString()
      this.job.studio = this.selectedStudio._id;

      // Update the postAll field based on the selected postScope
      this.job.postAll = this.postScope === 'allCleaners';

      // Create a list of all unselected cleaners
      this.job.rejectedCleaners = this.selectedStudio.cleaner
        .filter(cleaner => this.job.rejectedCleaners.includes(cleaner._id))
        .map(cleaner => cleaner._id);

      this.$store.dispatch("job/createJob", this.job);
      this.$router.push("/")
    },
    editJob() {
          let date = new Date(this.job.dateOfJob)
    let userTimezoneOffset = date.getTimezoneOffset() * 60000;
    let test = new Date(date.getTime() - userTimezoneOffset - 3600000);

      this.job.dateOfJob = test.toISOString();

      // Update the postAll field based on the selected postScope
      this.job.postAll = this.postScope === 'allCleaners';
      
      this.$store.dispatch("job/updateJob", this.job);
      this.$router.push("/")
    },
    goto(path){
      this.$router.push({ path })
    },
            getJobById(id){
        let filtered = this.jobs.filter(studio => {
        if (studio._id == id) return studio
      })
      return filtered[0]
    }
  },
  mounted() {

        if (this.$route.params.index) {
    this.index = this.$route.params.index;
    this.job = this.getJobById(this.index);
          this.update = true;
    }
  },
};
</script>

<style>

.mx-datepicker{
  width: 100%;
}

.mx-datepicker input{
  border-radius: 0.375rem;
  appearance: none;
  background-color: #fff;
  border-color: rgb(173, 173, 173);
  border-width: 1px;
  padding-top: 1.1rem;
  padding-right: 0.75rem;
  padding-bottom: 1.1rem;
  padding-left: 0.75rem;
}
</style>